// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SO8a70","container__visible":"_1St3kFK","header":"LugcOmY","close":"R1CKLoS","secondary":"_2ALYZ5D","item":"_1XBO_x3","item__visible":"GSjf4AI"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideSecondaryNavigation/index.css
// module id = ./template/components/Navigation/SideSecondaryNavigation/index.css
// module chunks = client.sitechrome